<template>
  <v-container fluid>
    <!-- Dates -->
    <v-row class="align-center mb-4">
      <v-col cols="12" sm="4">
        <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startDate"
              label="Début"
              readonly
              v-bind="attrs"
              v-on="on"
              dense
              outlined
            />
          </template>
          <v-date-picker v-model="startDate" @input="menuStart = false" :max="endDate" />
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4">
        <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endDate"
              label="Fin"
              readonly
              v-bind="attrs"
              v-on="on"
              dense
              outlined
            />
          </template>
          <v-date-picker v-model="endDate" @input="menuEnd = false" :min="startDate" :max="today" />
        </v-menu>
      </v-col>
      <v-col cols="12" sm="4" class="button-search">
        <v-btn color="primary" outlined :loading="loading" @click="fetchData">Appliquer</v-btn>
      </v-col>
    </v-row>

    <!-- Loader / overlay -->
    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-3" />
    <v-skeleton-loader
      v-if="loading && !hasData"
      type="article, image, image"
      class="mb-4"
    />

    <v-row>
      <v-col cols="12" sm="6">
        <v-row>
          <v-col cols="12" sm="6">
            <v-card class="pa-4 bg-warm-flame card" outlined  :to="{ name: 'AdminUsers' }">
              <div class="text-h4">{{ formatNumber(metrics.user_total) }}</div>
              <div class="caption text-h6">Total Utilisateurs</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card class="pa-4 bg-tempting-azure card" outlined :to="{ name: 'AdminUsers', query: { type: 'web' } }">
              <div class="text-h4">{{ formatNumber(metrics.user_web) }}</div>
              <div class="caption text-h6">Utilisateurs B2B</div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6">
            <v-card class="pa-4 bg-tempting-azure card" outlined :to="{ name: 'AdminUsers', query: { type: 'mobile' } }">
              <div class="text-h4">{{ formatNumber(metrics.user_fidelity) }}</div>
              <div class="caption text-h6">Carte de Fidélité</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card class="pa-4 bg-tempting-azure card" outlined :to="{ name: 'AdminUsers', query: { type: 'pro_mobile' } }">
              <div class="text-h4">{{ formatNumber(metrics.user_pro_mobile) }}</div>
              <div class="caption text-h6">Compte Pompiste</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card class="pa-4 bg-tempting-azure card" outlined :to="{ name: 'AdminVehicles' }">
              <div class="text-h4">{{ formatNumber(metrics.user_vehicle) }}</div>
              <div class="caption text-h6">Véhicules</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card class="pa-4 bg-tempting-azure card" outlined :to="{ name: 'AdminVehicles', query: { status: 'blocked' } }">
              <div class="text-h4">{{ formatNumber(metrics.blocked_vehicles) }}</div>
              <div class="caption text-h6">Véhicules Bloqué</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6">
        <v-row>
          <v-col cols="12" sm="6">
            <v-card class="pa-4 card bg-plum-plate text-light" outlined :to="{ name: 'PartnerCompany' }">
              <div class="text-h4">{{ formatNumber(metrics.active_companies) }}</div>
              <div class="caption text-h6">Entreprises actives</div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6">
            <v-card class="pa-4 card bg-asteroid text-light" outlined :to="{ name: 'AdminActivities' }">
              <div class="text-h4">{{ formatNumber(metrics.activity_amount_total) }}</div>
              <div class="caption text-h6">Transaction (XOF)</div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6">
            <v-card class="pa-4 card bg-night-sky text-light" outlined :to="{ name: 'AdminActivities' }">
              <div class="text-h4">{{ formatNumber(metrics.activity_total) }}</div>
              <div class="caption text-h6">Nonbre de transaction</div>
            </v-card>
          </v-col>

          
          <v-col cols="12" sm="6">
            <v-card class="pa-4 card bg-slick-carbon text-light" outlined :to="{ name: 'AdminVouchers' }">
              <div class="text-h4">{{ formatNumber(metrics.voucher_total) }}</div>
              <div class="caption text-h6">Bons émis</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card class="pa-4 card bg-focus text-light" outlined :to="{ name: 'PartnerCards' }">
              <div class="text-h4">{{ formatNumber(metrics.partner_card_total) }}</div>
              <div class="caption text-h6">Cartes partenaires</div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6">
            <v-card class="pa-4 card bg-vicious-stance text-light" outlined :to="{ name: 'PartnerCards' }">
              <div class="text-h4">{{ formatNumber(metrics.partner_card_active) }}</div>
              <div class="caption text-h6">Cartes actives</div>
            </v-card>
          </v-col>

        </v-row>
      </v-col>
      
    </v-row>


    <!-- Répartition entreprises -->
    <v-row class="mt-4">
      <v-col cols="12" sm="6">
        <v-card class="pa-4 bgTable">
          <div class="caption text-h6 mb-2">Répartition des types d'entreprises</div>
          <div class="text-caption grey--text mb-2">
            Total : {{ formatNumber(companiesTypeTotal) }} entreprises actives
          </div>
          <apexchart
            type="donut"
            height="320"
            :series="companiesByType.map(i => i.count)"
            :options="companiesTypeOptions"
          />
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card class="pa-4 bgTable">
          <div class="caption text-h6">Entreprises avec le plus de bons émis</div>
          <apexchart
            type="bar"
            height="300"
            :series="[
              {
                name: 'Bons',
                data: topVoucherCompanies.map(i => i.total)
              }
            ]"
            :options="{
              chart: {
                toolbar: { show: false }
              },
              plotOptions: {
                bar: {
                  borderRadius: 4,
                  horizontal: false
                }
              },
              colors: ['#000000'],  // Toutes les barres en noir
              xaxis: {
                categories: topVoucherCompanies.map(i => i.vehicle__company__name || i['vehicle__company__name']),
                labels: {
                  style: {
                    fontSize: '12px'
                  }
                }
              },
              dataLabels: {
                enabled: true
              },
              legend: {
                show: false
              }
            }"
          />
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import AdminServices from "@/services/AdminServices";

export default {
  name: "AdminDashboard",
  data() {
    return {
      startDate: null,
      endDate: null,
      today: new Date().toISOString().substr(0, 10),
      menuStart: false,
      menuEnd: false,
      metrics: {},
      loading: false,
    };
  },
  computed: {
    cards() {
      return [
        { label: "Utilisateurs", value: this.metrics.user_total },
        { label: "Web", value: this.metrics.user_web },
        { label: "Fidélité", value: this.metrics.user_fidelity },
        { label: "Pro Mobile", value: this.metrics.user_pro_mobile },
        { label: "Véhicule", value: this.metrics.user_vehicle },
        { label: "Entreprises actives", value: this.metrics.active_companies },
        { label: "Activités", value: this.metrics.activity_total },
        { label: "Montant total", value: this.metrics.activity_amount_total + " XOF" },
        { label: "Véhicules bloqués", value: this.metrics.blocked_vehicles },
        { label: "Bons émis", value: this.metrics.voucher_total },
        { label: "Cartes partenaires", value: this.metrics.partner_card_total },
        { label: "Cartes actives", value: this.metrics.partner_card_active },
      ];
    },
    companiesByType() {
      return this.metrics.companies_by_type || [];
    },
    companiesTypeTotal() {
      return this.companiesByType.reduce((s, i) => s + (Number(i.count) || 0), 0);
    },
    companiesTypeOptions() {
      const labels = this.companiesByType.map(i => i.company_type);
      const total = this.companiesTypeTotal;
      return {
        labels,
        colors: ["#1976d2", "#ef6c00"],  // Bleu B2B / Orange Partners
        legend: { position: "bottom", fontSize: "13px" },
        dataLabels: {
          enabled: true,
          formatter: (val, opts) => {
            const count = opts.w.config.series[opts.seriesIndex] || 0;
            return `${count} (${Math.round(val)}%)`;
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "Total",
                  color: "#5f6368",
                  fontSize: "13px",
                  formatter: () => total.toString(),
                },
              },
            },
          },
        },
        tooltip: {
          y: { formatter: val => `${val} entreprise${val > 1 ? "s" : ""}` },
        },
      };
    },
    topVoucherCompanies() {
      return this.metrics.top_voucher_companies || [];
    },
    hasData() {
      return Object.keys(this.metrics || {}).length > 0;
    },
  },
  created() {
    const today = new Date();
    this.endDate = today.toISOString().substr(0, 10);
    const lastWeek = new Date(today);
    lastWeek.setDate(today.getDate() - 7);
    this.startDate = lastWeek.toISOString().substr(0, 10);
    this.fetchData();
  },
  methods: {
    formatNumber(value) {
      if (!value) return "0";
      const rounded = Math.round(Number(value));
      return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          start_date: this.startDate,
          end_date: this.endDate,
        };
        const data = await AdminServices.getSummary(params);
        this.metrics = data;
      } catch (err) {
        console.error(err);
        this.$store.commit("app/message", {
          msg: "Erreur de chargement du tableau de bord",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.card.mb-3 {
  margin-bottom: 30px !important;

}
.widget-chart.text-left {
  flex-direction: row;

  align-items: center;

}
.widget-chart {
  text-align: center;

  padding: 1rem;

  position: relative;

}
.card {
  box-shadow: 0 0.46875rem 2.1875rem rgba(4,9,20,0.03),0 0.9375rem 1.40625rem rgba(4,9,20,0.03),0 0.25rem 0.53125rem rgba(4,9,20,0.05),0 0.125rem 0.1875rem rgba(4,9,20,0.03);

  border: 1px solid rgba(0, 0, 0, 0.6) !important;

  transition: all .2s;

}
.bg-tempting-azure {
  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;
}

.bg-warm-flame {
  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;
}
.bg-vicious-stance {
  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;
}
.bg-asteroid {
  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;
}
.bg-plum-plate {
  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}
.text-light {
  color: white !important;
}
.bg-night-sky {
  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;
}
.bg-focus {
  background-color: #444054 !important;
}
.bg-slick-carbon {
  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%),linear-gradient(to top, rgba(255,255,255,0.4) 0%, rgba(0,0,0,0.25) 200%) !important;
  background-blend-mode: multiply;
}
.button-search {
  margin-top: -20px !important;
}
</style>